"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const icon_1 = __importDefault(require("../../components/icon/icon"));
const styles_1 = __importDefault(require("../../styles/styles"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const constants_1 = require("../../constants/constants");
const eventConstants_1 = require("../../constants/eventConstants");
const screenConstants_1 = require("../../constants/screenConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const typesConstants_1 = require("../../constants/typesConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const paginatedMessageComponent_1 = __importDefault(require("../../components/messageComponent/paginatedMessageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const actionsSlice_1 = require("./actionsSlice");
const scheduleActionsTable_1 = __importDefault(require("../../components/scheduleActions/scheduleActionsTable"));
const filterScheduleActions_1 = __importDefault(require("../../components/filterScheduleActions/filterScheduleActions"));
const ScheduleActions = () => {
    const dispatch = useAppDispatch_1.default();
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_2);
    const navigator = native_1.useNavigation();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const { scheduleActions, loadingStatus } = useAppSelector_1.default((state) => ({
        scheduleActions: state.actions.scheduleActions.scheduleActions,
        loadingStatus: state.actions.scheduleActions.loadingStatus,
    }));
    const [queryParams, setQueryParams] = react_1.useState({});
    const onPageChange = (page) => {
        dispatch(actionsSlice_1.resetActionState());
        dispatch(actionsSlice_1.getScheduleActions({ ...queryParams, page }));
    };
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(actionsSlice_1.getScheduleActions({ ...queryParams }));
    }, []));
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS || scheduleActions.length > 0) {
        if (scheduleActions.length === 0) {
            content = (react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No Schedule actions Found.", color: colors_1.default.BLUE, icon: free_solid_svg_icons_1.faSadTear }));
        }
        else {
            content = (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(scheduleActionsTable_1.default, { onPageChange: onPageChange })));
        }
    }
    else {
        content = (react_1.default.createElement(messageComponent_1.default, { message: "No schedule actions Found.", color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle }));
    }
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Schedule Actions" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Dashboard `)))))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
                react_1.default.createElement(filterScheduleActions_1.default, { setQueryParams: setQueryParams, queryParams: queryParams }),
                content))));
};
exports.default = ScheduleActions;
